export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "stream_worker.c6a72e48.worker.js");
}
